import { CallbackTranslation } from '../../locale/localizationContext';

import emptyCart from '../../assets/images/empty-state-cart.png';
import emptyAddressesList from '../../assets/images/empty-state-addresses.png';

export enum EmptyStateType {
  Cart = 'cart',
  Addresses = 'addresses',
  PickUpPoint = 'pickUpPoint',
}

export type EmptyStateDetail = {
  title: string;
  description: string;
  image?: string;
};

export const getEmptyStateDetails = (
  type: EmptyStateType,
  t: CallbackTranslation
): EmptyStateDetail | null => {
  switch (type) {
    case EmptyStateType.Cart:
      return {
        description: t('cart.emptyStateDescription'),
        title: t('cart.emptyStateTitle'),
        image: emptyCart,
      };
    case EmptyStateType.Addresses:
      return {
        description: t('addresses.emptyStateDescription'),
        title: t('addresses.emptyStateTitle'),
        image: emptyAddressesList,
      };
    case EmptyStateType.PickUpPoint:
      return {
        description: t('pickUp.emptyStateDescription'),
        title: t('pickUp.emptyStateTitle'),
      };
    default:
      return null;
  }
};
